import header from './header.json';

const kr = {
  ...header,
};

export { kr };
